import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.99992 10.8333C10.4602 10.8333 10.8333 10.4602 10.8333 9.99996C10.8333 9.53972 10.4602 9.16663 9.99992 9.16663C9.53968 9.16663 9.16659 9.53972 9.16659 9.99996C9.16659 10.4602 9.53968 10.8333 9.99992 10.8333Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8333 10.8333C16.2935 10.8333 16.6666 10.4602 16.6666 9.99996C16.6666 9.53972 16.2935 9.16663 15.8333 9.16663C15.373 9.16663 14.9999 9.53972 14.9999 9.99996C14.9999 10.4602 15.373 10.8333 15.8333 10.8333Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.16659 10.8333C4.62682 10.8333 4.99992 10.4602 4.99992 9.99996C4.99992 9.53972 4.62682 9.16663 4.16659 9.16663C3.70635 9.16663 3.33325 9.53972 3.33325 9.99996C3.33325 10.4602 3.70635 10.8333 4.16659 10.8333Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMoreHorizontal;
